var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_26208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3316 5.13469C24.8841 4.7504 24.4151 4.39188 23.9269 4.06086L23.9782 4.00958L23.2935 3.64136L23.089 3.5064L23.0725 3.52256L22.7938 3.37266C20.0793 1.91291 16.9666 1.36703 13.9174 1.81598C10.8681 2.26493 8.04485 3.68481 5.86629 5.86498C3.68772 8.04516 2.26993 10.8695 1.82323 13.919C1.37653 16.9686 1.92471 20.0809 3.38646 22.7943L3.52049 23.0431L3.50675 23.0566L3.63796 23.2612L4.03082 23.9904L4.07774 23.9425C4.40571 24.4334 4.76678 24.9014 5.15849 25.3434L5.86321 26.1384L6.6142 25.3869L25.3875 6.60024L26.1499 5.83731L25.3316 5.13469ZM28.6139 9.20578L28.4799 8.95698L28.4936 8.94346L28.3624 8.73893L27.9695 8.00968L27.9226 8.05759C27.5946 7.56672 27.2336 7.09868 26.8419 6.65675L26.1371 5.86167L25.3862 6.6132L6.61282 25.3999L5.85043 26.1628L6.66873 26.8654C7.11629 27.2497 7.58529 27.6082 8.07344 27.9392L8.02216 27.9905L8.70687 28.3587L8.91139 28.4937L8.92781 28.4776L9.20655 28.6274C11.921 30.0872 15.0338 30.6331 18.083 30.1841C21.1322 29.7352 23.9555 28.3153 26.1341 26.1351C28.3126 23.955 29.7304 21.1306 30.1771 18.0811C30.6238 15.0315 30.0756 11.9192 28.6139 9.20578Z",
    fill: "white",
    stroke: "#C52928",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9815_26208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.bd21ad73c612c9ebf5b2e00c794616f4.svg";
export { ForwardRef as ReactComponent };